import React from 'react';
import { Badge } from '@/components/ui';
import type { ReworkStatus } from '../types/construction-rework.types';

interface Props {
  status: ReworkStatus;
  className?: string;
}

const statusConfig: Partial<Record<ReworkStatus, { label: string; color: string }>> = {
  draft: { label: 'Bản thảo', color: 'bg-slate-100 text-slate-600' },
  submitted: { label: 'Đã gửi', color: 'bg-amber-100 text-amber-600' },
  approved: { label: 'Đã duyệt', color: 'bg-indigo-100 text-indigo-600' },
  assigned: { label: 'Đã giao việc', color: 'bg-blue-100 text-blue-600' },
  in_progress: { label: 'Đang sửa', color: 'bg-sky-100 text-sky-600' },
  reinspection_pending: { label: 'Chờ nghiệm thu', color: 'bg-orange-100 text-orange-600' },
  completed: { label: 'Hoàn thành', color: 'bg-emerald-100 text-emerald-600' },
  closed: { label: 'Đã đóng', color: 'bg-slate-900 text-white' },
  cancelled: { label: 'Đã hủy', color: 'bg-slate-200 text-slate-400' },
};

export const ReworkStatusBadge: React.FC<Props> = ({ status, className }) => {
  const config = statusConfig[status] || { label: status, color: 'bg-slate-100 text-slate-600' };
  
  return (
    <Badge className={`${config.color} border-transparent text-[10px] font-bold ${className}`}>
      {config.label}
    </Badge>
  );
};
